import Axios from "@/utils/Axios";
import config from "@/config";

export interface GetSetsListType {
  user_id: number;
  page_size: number;
  page_index: number;
}

export interface GetSetsImgsType {
  user_id: number;
  page_size: number;
  page_index: number;
}

export interface GetMyLikeType {
  user_id?: number; // 0 代表当前用户
  page_size: number;
  page_index: number;
}

export interface DelReleaseType {
  opus_id: number;
  image_ids?: number[];
  del_type: 1 | 2; // 1:删除设计中的图片(需要带上imageIds); 2:删除整个设计(不用传ImageIds)
}

export function getSetsList(data: GetSetsListType) {
  return Axios.post(`/ai_creator/opus/list`, data, {}, config.adminUrl);
}

export function getSetsImgs(data: GetSetsImgsType) {
  return Axios.post(`/ai_creator/opus/image_list`, data, {}, config.adminUrl);
}

export function delRelease(data: DelReleaseType) {
  return Axios.post(`/ai_creator/opus/del`, data, {}, config.adminUrl);
}

export function fetchMyLikeList(data: GetMyLikeType) {
  return Axios.get(
    `/ai_creator/user/likes`,
    {
      user_id: data.user_id || 0, // 0 代表当前用户
      page_size: data.page_size,
      page_index: data.page_index,
    },
    {},
    config.adminUrl,
  );
}

export function fetchFollowList(data: { page_size: number; page_index: number }) {
  return Axios.post(`/ai_creator/follow/followling`, data, {}, config.gwURL);
}

export function setUnLike(data: { image_id: string }) {
  return Axios.post(`/ai_creator/likes/cancel`, data, {}, config.adminUrl);
}

export function setLike(data: { image_id: string }) {
  return Axios.post(`/ai_creator/likes/add`, data, {}, config.adminUrl);
}

export function getUserBaseInfo(data: { user_id: number }) {
  return Axios.get(`/ai_creator/user/info`, data, {}, config.gwURL);
}

export function getUserStatisticsInfo(data: { user_id: string }) {
  return Axios.post(`/ai_creator/user/statistics`, data, {}, config.gwURL);
}

export function createFollow(data: { to_user_id: string }) {
  return Axios.post("/ai_creator/follow/create", data, {}, config.gwURL);
}

export function cancelFollow(data: { to_user_id: string }) {
  return Axios.post("/ai_creator/follow/cancel", data, {}, config.gwURL);
}
